module.exports = __webpack_public_path__ + "img/invoice-de-male-banner-by.80aa578c.png";